module.exports = __webpack_public_path__ + "img/portal-download-url-list.9d10a747.jpg";